<template>
  <div class="list">
    <ToolTitle :title="'Form Listesi'" :menu="false" />
    <div class="list__wrapper">
      <div class="list__input">
        <FormSearch :placeholder="'Form ara...'" v-model.trim="search" />
      </div>
      <div v-if="!nodata" class="list__items -nohover">
        <div class="list__items__item -title -first">Form adı</div>
        <div class="list__items__item -title">Marka</div>
        <!-- <div class="list__items__item -title">Oluşturan</div>
        <div class="list__items__item -title">Son düzenleyen</div>-->
        <div class="list__items__item -title">Url</div>
        <div class="list__items__item -title">Doldurulma</div>
        <div class="list__items__item -title -last">Durum</div>
      </div>
      <ToolLoading v-if="!isloaded" />
      <div class="list__items" v-for="(item, index) in filteredList" :key="index">
        <div class="list__items__item -link -first" @click="open(item)">{{item.name}}</div>
        <div class="list__items__item">{{item.company.name}}</div>
        <!-- <div
          class="list__items__item -info"
          :title="item.created.date"
        >{{item.created.by | filtername}}</div>
        <div
          class="list__items__item -info"
          :title="item.updated.date"
        >{{item.updated.by | filtername}}</div>-->
        <div class="list__items__item -copy" v-copy="`${site}/${item.company.path}/${item.path}`"></div>
        <div class="list__items__item">{{item.count}}</div>
        <div class="list__items__item -last">
          <FormCheckbox v-model="item.status" @action="update(item)" />
        </div>
      </div>
      <div class="list__nodata" v-if="nodata && isloaded">
        <div class="list__nodata__image">
          <IconNoimage />
        </div>
        <div class="list__nodata__message">Üzgünüz, aradığınız kriterlere uygun bir form bulunamadı.</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "@/services/";
import { global } from "@/global";
import { copy } from "@/directives/";
import * as Helpers from "@/helpers/";

export default {
  data() {
    return {
      forms: [],
      isloaded: false,
      site: `${global["API"]}/${global["FORMPATH"]}`,
      search: ""
    };
  },
  directives: { copy },
  created() {
    this.init();
  },
  computed: {
    filteredList() {
      return this.forms.filter(item => {
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    nodata() {
      return this.filteredList.length > 0 ? false : true;
    }
  },
  filters: {
    filtername(name) {
      return name.split("@")[0];
    }
  },
  methods: {
    init: async function() {
      let vm = this;

      await API.getForms().then(response => (vm.forms = response.result));

      vm.isloaded = true;
    },
    open: async function(form) {
      await this.$store.dispatch("setActiveCompany", form.company).then(() =>
        this.$router.push({
          name: "form",
          params: { form: form.path, company: form.company.path }
        })
      );
    },
    update: async function(form) {
      form.updated = {
        by: this.$store.getters.getUser,
        date: await Helpers.currentDateTime()
      };

      await API.updateForm(form);
    }
  }
};
</script>